/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_Delta_HintInputs */

const en_us2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the difference as a direction, not as an exact measurement: the two estimates' ranges overlap.`)
};

const pt_br2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia a diferença como direção, não como medida exata: as faixas das duas estimativas se sobrepõem.`)
};

const es_419_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee la diferencia como una dirección, no como una medida exacta: los rangos de las dos estimaciones se superponen.`)
};

const pt_pt2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lê a diferença como uma direção, não como uma medida exata: os intervalos das duas estimativas sobrepõem-se.`)
};

const fr_fr2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lis l'écart comme une tendance, pas comme une mesure exacte : les fourchettes des deux estimations se chevauchent.`)
};

const de_de2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lies den Unterschied als Richtung, nicht als exakte Messung: Die Spannen der beiden Schätzungen überlappen sich.`)
};

const it_it2_body_assessment_compare_delta_hint = /** @type {(inputs: Body_Assessment_Compare_Delta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi la differenza come una direzione, non come una misura esatta: gli intervalli delle due stime si sovrappongono.`)
};

/**
* | output |
* | --- |
* | "Read the difference as a direction, not as an exact measurement: the two estimates' ranges overlap." |
*
* @param {Body_Assessment_Compare_Delta_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_delta_hint = /** @type {((inputs?: Body_Assessment_Compare_Delta_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Delta_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_delta_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_delta_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_delta_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_delta_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_delta_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_delta_hint(inputs)
	return en_us2_body_assessment_compare_delta_hint(inputs)
});
export { body_assessment_compare_delta_hint as "body-assessment.compare_delta_hint" }